// Sayfa bazlı çeviri dosyaları burada birleştirilir (translations.js'i şişirmemek için).
// Her dosya { tr: {...}, en: {...} } döner; anahtarlar iç içe (ör. "leavesPage.tabs.all").
import leaves from "./leaves";
import sat from "./sat";
import admin from "./admin";
import fleet from "./fleet";

const merge = (target, src) => {
  Object.entries(src || {}).forEach(([k, v]) => {
    if (v && typeof v === "object" && !Array.isArray(v)) {
      target[k] = merge(target[k] && typeof target[k] === "object" ? target[k] : {}, v);
    } else {
      target[k] = v;
    }
  });
  return target;
};

export const extraTranslations = { tr: {}, en: {} };
[leaves, sat, admin, fleet].forEach((mod) => {
  merge(extraTranslations.tr, mod.tr);
  merge(extraTranslations.en, mod.en);
});
